import ModalComponent from './ModalComponent';

export default ModalComponent;
